import { h } from 'preact';
import { Select } from '../Select';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'Select',
  category: '📝 Formulários',
  description: 'Dropdown de seleção com label e opções',
  usedIn: ['AgentesPage', 'Integrations', 'Profile'],
  example: () => (
    <Select
      label="Opções"
      value="op1"
      onChange={() => {}}
      options={[
        { value: 'op1', label: 'Opção 1' },
        { value: 'op2', label: 'Opção 2' },
        { value: 'op3', label: 'Opção 3' },
      ]}
    />
  ),
};
